import React from "react";
import { Helmet } from "react-helmet";

export default function GurugramPage() {

  const services = [
    "SEO Services",
    "Google Ads Management",
    "Social Media Marketing",
    "Performance Marketing",
    "Local SEO",
    "Lead Generation",
  ];

  const industries = [
    {
      title: "SaaS Companies",
      desc: "Scalable SEO systems and performance marketing strategies for SaaS startups and software brands.",
    },
    {
      title: "Real Estate",
      desc: "Google Ads and lead generation campaigns for builders, developers, and property consultants.",
    },
    {
      title: "Healthcare",
      desc: "SEO and local marketing strategies for hospitals, clinics, and healthcare brands.",
    },
    {
      title: "eCommerce",
      desc: "SEO, conversion optimization, and paid advertising for eCommerce businesses.",
    },
    {
      title: "Education",
      desc: "Digital marketing services for schools, coaching institutes, and edtech companies.",
    },
    {
      title: "Restaurants",
      desc: "Local SEO and social media marketing solutions for cafes and restaurants.",
    },
    {
      title: "Manufacturing",
      desc: "B2B lead generation and industrial marketing strategies for manufacturers.",
    },
    {
      title: "Startups",
      desc: "Growth-focused digital marketing campaigns designed for fast-growing startups.",
    },
  ];

  const faqs = [
    {
      q: "Why choose SoftCoders for digital marketing in Gurugram?",
      a: "SoftCoders provides SEO, Google Ads, local SEO, and performance marketing services focused on generating traffic, leads, and business growth.",
    },
    {
      q: "Do you provide local SEO services in Gurugram?",
      a: "Yes. We optimize Google Business Profiles, maps visibility, citations, and local landing pages for businesses across Gurugram.",
    },
    {
      q: "How long does SEO take in Gurugram?",
      a: "SEO generally takes 3 to 6 months depending on keyword competition, website authority, and industry demand.",
    },
    {
      q: "Do you work with startups and local businesses?",
      a: "Yes. We work with startups, SaaS companies, manufacturers, healthcare brands, educational institutions, and local businesses in Gurugram.",
    },
  ];

  return (

    <div className="bg-[#070B1A] text-white overflow-hidden">

     
  <Helmet>

    {/* PRIMARY SEO */}
    <title>
      Digital Marketing, Software & Website Development Company in Gurugram | SoftCoders
    </title>

    <meta
      name="description"
      content="SoftCoders is a digital marketing, software development, and website development company in Gurugram providing SEO services, Google Ads management, custom software development, ERP systems, CRM software, mobile app development, and scalable business website solutions."
    />

    <meta
      name="keywords"
      content="
      digital marketing company in gurugram,
      seo company in gurugram,
      google ads agency gurugram,
      local seo services gurugram,
      social media marketing company,
      performance marketing agency,
      lead generation company,
      digital marketing agency gurugram,
      seo services gurugram,
      website development company in gurugram,
      web development company gurugram,
      software company in gurugram,
      custom software development,
      ecommerce website development,
      business website development,
      responsive website design,
      mobile app development company,
      software development company india,
      crm software development,
      erp software company,
      custom web application development,
      startup software company,
      saas development company,
      it company in gurugram,
      local business seo,
      technical seo services,
      semantic seo agency,
      content marketing company,
      startup marketing agency,
      ecommerce marketing services,
      healthcare digital marketing,
      real estate marketing agency,
      school marketing services,
      online marketing company,
      ppc advertising agency,
      website ranking services,
      organic traffic growth,
      search engine optimization,
      business growth marketing,
      google ranking company,
      social media advertising,
      conversion optimization,
      digital growth agency
      "
    />

    <meta name="author" content="SoftCoders" />
    <meta name="robots" content="index, follow" />
    <meta name="language" content="English" />
    <meta name="revisit-after" content="2 days" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://softcoders.in/digital-marketing-gurugram"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Digital Marketing, Software & Website Development Company in Gurugram | SoftCoders"
    />

    <meta
      property="og:description"
      content="SEO services, Google Ads management, software development, ERP systems, mobile app development, and website development solutions in Gurugram."
    />

    <meta
      property="og:url"
      content="https://softcoders.in/digital-marketing-gurugram"
    />

    <meta property="og:type" content="website" />

    <meta
      property="og:image"
      content="https://softcoders.in/og-gurugram-digital-marketing.jpg"
    />

    {/* TWITTER SEO */}
    <meta name="twitter:card" content="summary_large_image" />

    <meta
      name="twitter:title"
      content="Digital Marketing, Software & Website Development Company in Gurugram | SoftCoders"
    />

    <meta
      name="twitter:description"
      content="Professional SEO services, software development, website development, Google Ads, and digital marketing solutions in Gurugram."
    />

    <meta
      name="twitter:image"
      content="https://softcoders.in/og-gurugram-digital-marketing.jpg"
    />

    {/* GEO SEO */}
    <meta name="geo.region" content="IN-HR" />
    <meta name="geo.placename" content="Gurugram" />
    <meta name="geo.country" content="India" />

    {/* MOBILE SEO */}
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />

    <meta
      name="theme-color"
      content="#070B1A"
    />

    {/* SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareCompany",
        name: "SoftCoders",
        url: "https://softcoders.in",
        logo: "https://softcoders.in/logo.png",
        image: "https://softcoders.in/og-gurugram-digital-marketing.jpg",
        description:
          "SoftCoders provides SEO services, website development, custom software development, ERP systems, mobile app development, and digital marketing solutions in Gurugram.",
        address: {
          "@type": "PostalAddress",
          addressRegion: "Haryana",
          addressLocality: "Gurugram",
          addressCountry: "India"
        },
        areaServed: {
          "@type": "City",
          name: "Gurugram"
        },
        sameAs: [
          "https://www.facebook.com/",
          "https://www.instagram.com/",
          "https://www.linkedin.com/"
        ],
        service: [
          {
            "@type": "Service",
            name: "SEO Services"
          },
          {
            "@type": "Service",
            name: "Google Ads Management"
          },
          {
            "@type": "Service",
            name: "Website Development"
          },
          {
            "@type": "Service",
            name: "Custom Software Development"
          },
          {
            "@type": "Service",
            name: "ERP Software Development"
          },
          {
            "@type": "Service",
            name: "Mobile App Development"
          }
        ]
      })}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Why choose SoftCoders in Gurugram?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "SoftCoders provides SEO services, software development, website development, ERP systems, and digital marketing solutions focused on business growth."
            }
          },
          {
            "@type": "Question",
            name: "Do you provide website development services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We develop business websites, eCommerce websites, custom web applications, and scalable platforms."
            }
          },
          {
            "@type": "Question",
            name: "Do you provide software development services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We develop ERP software, CRM systems, HRMS software, billing software, and custom business automation platforms."
            }
          },
          {
            "@type": "Question",
            name: "Do you provide SEO services in Gurugram?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We provide technical SEO, local SEO, semantic SEO, Google ranking optimization, and content marketing services."
            }
          }
        ]
      })}
    </script>

  </Helmet>

      {/* HERO */}
      <section className="relative overflow-hidden border-b border-white/5 py-28">

        {/* GRID */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(99,102,241,.4) 1px, transparent 1px),
              linear-gradient(90deg, rgba(99,102,241,.4) 1px, transparent 1px)
            `,
            backgroundSize: "80px 80px",
          }}
        />

        {/* GLOW */}
        <div className="absolute top-[-200px] right-[-200px] w-[600px] h-[600px] rounded-full bg-indigo-600/20 blur-3xl"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">

          <div className="max-w-5xl">

            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-indigo-500/20 bg-indigo-500/10 text-indigo-300 text-sm font-medium">

              <div className="w-2 h-2 rounded-full bg-indigo-400"></div>

              Gurugram Digital Marketing Agency

            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-[0.9] mt-8">

              Digital Marketing Services
              <span className="block text-indigo-400 mt-2">
                in Gurugram
              </span>

            </h1>

            <p className="text-slate-400 text-lg leading-8 mt-8 max-w-4xl">

              SoftCoders provides digital marketing services in Gurugram
              including SEO services, Google Ads management,
              local SEO, social media marketing,
              performance marketing,
              and lead generation strategies
              designed to increase traffic, conversions, and revenue.

            </p>

            {/* BUTTONS */}
            <div className="flex flex-wrap gap-5 mt-10">

              <a
    href="/contact"
 className="bg-indigo-600 hover:bg-indigo-500 transition-all duration-300 px-8 py-4 rounded-2xl font-bold shadow-[0_15px_40px_rgba(99,102,241,0.25)]">
                Get Free Marketing Audit
              </a>

              <a
    href="https://wa.me/919254147455?text=Hello%20SoftCoders%2C%20I%20want%20to%20discuss%20my%20project."
    target="_blank"
    rel="noopener noreferrer"
 className="border border-white/10 hover:border-indigo-500/40 px-8 py-4 rounded-2xl text-slate-300 transition-all duration-300">
                Talk To Marketing Expert
              </a>

            </div>

            {/* STATS */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">

              {[
                ["850%", "Traffic Growth"],
                ["32M+", "Ad Impressions"],
                ["7.1x", "Lead Increase"],
                ["420+", "Businesses Served"],
              ].map(([num, label], i) => (

                <div key={i}>

                  <div className="text-4xl font-black text-indigo-400">
                    {num}
                  </div>

                  <div className="text-slate-500 mt-2">
                    {label}
                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>

      </section>

      {/* SEO CONTENT */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-5xl mx-auto px-6 lg:px-10">

          <h2 className="text-5xl font-black leading-tight">

            Best Digital Marketing Company in Gurugram

          </h2>

          <div className="space-y-8 text-slate-400 text-lg leading-9 mt-10">

            <p>

              SoftCoders is a digital marketing company in Gurugram
              helping businesses improve online visibility,
              generate qualified leads,
              increase organic traffic,
              and scale business growth through SEO,
              Google Ads,
              social media marketing,
              and performance marketing strategies.

            </p>

            <p>

              Our digital marketing experts work with startups,
              SaaS companies,
              IT firms,
              healthcare brands,
              educational institutions,
              eCommerce businesses,
              real estate companies,
              manufacturers,
              and local businesses across Gurugram.

            </p>

            <p>

              We provide technical SEO,
              local SEO optimization,
              PPC advertising,
              social media campaigns,
              conversion optimization,
              content marketing,
              and growth-focused digital marketing solutions
              designed for highly competitive markets.

            </p>

            <p>

              Our SEO services in Gurugram include
              keyword research,
              on-page SEO optimization,
              Core Web Vitals improvements,
              schema markup,
              authority backlink building,
              semantic content systems,
              internal linking strategies,
              and scalable ranking systems
              focused on long-term search visibility.

            </p>

            <p>

              We help businesses rank for competitive keywords like
              digital marketing company in Gurugram,
              SEO company in Gurugram,
              Google Ads agency in Gurugram,
              social media marketing company Gurugram,
              local SEO services Gurugram,
              and performance marketing agency Gurugram.

            </p>

          </div>

        </div>

      </section>

      {/* SERVICES */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-7xl mx-auto px-6 lg:px-10">

          <div className="text-center max-w-3xl mx-auto">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              SERVICES
            </div>

            <h2 className="text-5xl font-black mt-6">

              Digital Marketing Services in Gurugram

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">

            {services.map((service, i) => (

              <div
                key={i}
                className="
                  rounded-3xl
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                  hover:border-indigo-500/30
                  transition-all
                  duration-300
                "
              >

                <div className="w-14 h-14 rounded-2xl bg-indigo-500/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400 text-2xl mb-6">
                  →
                </div>

                <h3 className="text-2xl font-bold">
                  {service}
                </h3>

                <p className="text-slate-400 mt-5 leading-8">

                  Professional {service.toLowerCase()} solutions
                  designed to improve rankings,
                  generate qualified leads,
                  and scale business growth in Gurugram.

                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* INDUSTRIES */}
      <section className="relative py-28 border-b border-white/5 overflow-hidden">

        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-500/10 blur-3xl rounded-full"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">

          <div className="max-w-4xl">

            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-indigo-500/20 bg-indigo-500/10 text-indigo-300 text-sm font-medium">

              <div className="w-2 h-2 rounded-full bg-indigo-400"></div>

              Industries We Serve

            </div>

            <h2 className="text-5xl lg:text-6xl font-black leading-[0.95] mt-8">

              Industries We Help
              <span className="block text-indigo-400 mt-2">
                Grow in Gurugram
              </span>

            </h2>

            <p className="text-slate-400 text-lg leading-8 mt-8 max-w-3xl">

              SoftCoders provides SEO services,
              Google Ads management,
              social media marketing,
              local SEO,
              and performance marketing solutions
              for businesses across multiple industries in Gurugram.

            </p>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">

            {industries.map((industry, i) => (

              <div
                key={i}
                className="
                  group
                  relative
                  overflow-hidden
                  rounded-[32px]
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                  hover:border-indigo-500/30
                  hover:-translate-y-2
                  transition-all
                  duration-500
                "
              >

                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500 bg-gradient-to-br from-indigo-500/[0.08] to-transparent"></div>

                <div
                  className="
                    relative
                    z-10
                    w-16
                    h-16
                    rounded-2xl
                    bg-indigo-500/10
                    border
                    border-indigo-500/20
                    flex
                    items-center
                    justify-center
                    text-indigo-400
                    text-2xl
                    mb-8
                  "
                >
                  →
                </div>

                <div className="relative z-10">

                  <h3 className="text-2xl font-black group-hover:text-indigo-300 transition-all duration-300">

                    {industry.title}

                  </h3>

                  <p className="text-slate-400 leading-8 mt-5">

                    {industry.desc}

                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* FAQ */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-4xl mx-auto px-6 lg:px-10">

          <div className="text-center mb-20">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              FAQ
            </div>

            <h2 className="text-5xl font-black mt-6">

              Frequently Asked Questions

            </h2>

          </div>

          <div className="space-y-6">

            {faqs.map((faq, i) => (

              <div
                key={i}
                className="
                  rounded-3xl
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                "
              >

                <h3 className="text-2xl font-bold">

                  {faq.q}

                </h3>

                <p className="text-slate-400 leading-8 mt-4">

                  {faq.a}

                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

    </div>

  );
}